import { titleLabelAccessibility } from 'owa-calendar-shared-strings/lib/strings/calendarEventTitleAndCharm.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';

import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import truncateTitle from 'owa-calendar-forms-common/lib/utils/truncateTitle';
import { CharmControl, CharmControlColorPattern, CharmControlColorProps } from 'owa-charmcontrol';
import { CharmInfo } from 'owa-calendar-charms-store';
import { getOptimalTextColorString } from 'owa-color-utils/lib/colorUtils';
import { getPaletteAsRawColors } from 'owa-theme';
import { observer } from 'mobx-react-lite';
import { getCalendarEventItemSubjectText } from 'owa-calendar-event-attributes';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

const styles = require('./CalendarItemPeek.scss');
const classNames = require('classnames/bind').bind(styles);

const MAX_LENGTH = 80;

export interface TitleAndCharmProps {
    colorScheme: ColorScheme;
    event: CalendarEvent;
    charmInfo: CharmInfo;
    strikethrough: boolean;
}

const TitleAndCharm = observer(function TitleAndCharm(props: TitleAndCharmProps) {
    const { event, charmInfo, colorScheme, strikethrough } = props;
    const textColor = getOptimalTextColorString(
        getPaletteAsRawColors().white,
        colorScheme,
        colorScheme.calPrimary
    );

    const colorProps: CharmControlColorProps = {
        colorPattern: CharmControlColorPattern.Normal,
        calPrimary: textColor,
    };

    const title = getCalendarEventItemSubjectText(event);

    return (
        <div className={styles.titleRow} key={'CharmRowKey' + charmInfo.IconId}>
            <div className={styles.charmIconContainer} title={charmInfo.LocalizedName}>
                <CharmControl
                    iconId={charmInfo.IconId}
                    className={styles.charmIconTitle}
                    colorProps={colorProps}
                />
            </div>
            <span
                title={title && title.length > MAX_LENGTH ? title : undefined}
                style={{ color: textColor }}
                aria-label={loc(titleLabelAccessibility)}
                className={classNames(styles.titleText, 'allowTextSelection', {
                    strikethrough: strikethrough,
                })}>
                {truncateTitle(title, MAX_LENGTH)}
            </span>
        </div>
    );
});

export default TitleAndCharm;
